// Mock unified patient record for the demo. Tells Alex's story: pre-hypertension creeping up,
// sleep quietly deteriorating, undereating on travel days — the patterns SARA connects.
// (The chat AI is real; this record is illustrative demo data, consistent with the backend profile.)

export const PATIENT = {
  name: 'Alex Rivera',
  age: 41,
  sex: 'Male',
  mrn: 'BNR-4471902',
  pcp: 'Dr. Omar Haddad · Banner Health',
  plan: 'Banner Health · SARA AI',
}

export const CONDITIONS = [
  { name: 'Pre-hypertension', since: '2024', source: 'Epic MyChart' },
  { name: 'Elevated cardiometabolic risk', since: '2025', source: 'SARA assessment' },
]

export const MEDICATIONS = [
  { name: 'Lisinopril 10 mg', schedule: 'Once daily (morning)', source: 'Epic MyChart' },
]

export const LABS = [
  { name: 'A1C', value: '6.1%', flag: 'borderline', date: 'Apr 2026', ref: '< 5.7%', source: 'Epic MyChart' },
  { name: 'LDL cholesterol', value: '138 mg/dL', flag: 'borderline', date: 'Apr 2026', ref: '< 100', source: 'Epic MyChart' },
  { name: 'Resting HR', value: '68 bpm', flag: 'normal', date: 'Today', ref: '60–100', source: 'Apple Watch' },
  { name: 'eGFR', value: '92', flag: 'normal', date: 'Apr 2026', ref: '> 60', source: 'Epic MyChart' },
]

// 7-day vitals trend (oldest → newest, last = today). `normal` draws a reference line.
export const DAY_LABELS = ['6d', '5d', '4d', '3d', '2d', 'Yest', 'Today']
export const TRENDS = [
  { metric: 'Systolic BP', unit: 'mmHg', source: 'Omron', series: [128, 130, 129, 132, 131, 134, 134], dir: 'up', concern: true, normal: 120, ref: '< 120 mmHg (normal)', note: 'Crept up ~6 mmHg over the week as sleep and steps fell.' },
  { metric: 'Sleep', unit: 'h', source: 'Oura', series: [7.1, 6.8, 6.5, 6.2, 6.0, 5.9, 5.8], dir: 'down', concern: true, normal: 7, ref: '7–9 h recommended', note: 'Steady decline — now below the 7 h target.' },
  { metric: 'Glucose (avg)', unit: 'mg/dL', source: 'Dexcom', series: [104, 106, 108, 110, 112, 109, 111], dir: 'up', concern: true, normal: 100, ref: 'Fasting < 100 mg/dL', note: 'Daily average drifting up; tracks with late, larger meals.' },
  { metric: 'Steps', unit: '', source: 'Apple Watch', series: [8200, 7400, 6100, 5200, 4800, 4200, 4200], dir: 'down', concern: false, normal: 7000, ref: '~7,000–10,000/day', note: 'Activity has dropped by roughly half this week.' },
  { metric: 'HRV', unit: 'ms', source: 'Oura', series: [62, 60, 58, 55, 54, 52, 51], dir: 'down', concern: true, normal: 55, ref: 'Higher is better (personal baseline ~60)', note: 'Falling HRV suggests rising strain / poorer recovery.' },
]
export type Trend = (typeof TRENDS)[number]

export const PATTERNS = [
  'Energy dips Thursday afternoons — tracks to late Tuesday meetings the same week.',
  'Undereats on travel days; CGM shows reactive spikes when meals resume late.',
  'Sleep best on nights screens stop by 10pm — averages +52 min deep sleep.',
  'Systolic BP has crept ~6 mmHg over 8 weeks as sleep and steps declined.',
]

export const CONNECTED_SOURCES = ['Epic MyChart', 'Apple Watch', 'Oura Ring', 'Dexcom', 'Omron']
